export function LabChevronDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" className="size-3.5" {...props}>
      <path stroke="currentColor" strokeWidth="1.1" d="m4 5.5 3 3 3-3" />
    </svg>
  );
}
export function LabChevronDownNotify(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4749_111)">
        <path d="M13 6L7 10L1 6" stroke="black" strokeWidth={1.16} />
      </g>
      <defs>
        <clipPath id="clip0_4749_111">
          <rect width={14} height={14} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
